<h3 modal-title>Resposta</h3>

<div modal-body  mat-dialog-content>
    <div fxLayout="row wrap" *ngIf="data.type != 'HR'">
        <div fxFlex.gt-sm="100%">
            <strong>Cliente Aceitou? </strong>{{data.cliente_aceitou? 'SIM' : 'NÃO'}}
        </div>
    </div>   
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <strong>Data da Resposta: </strong>{{data.data_resposta | date:'dd/MM/yyyy'}}
        </div>
    </div>
    <div fxLayout="row wrap" *ngIf="data.type != 'HR'">
        <div fxFlex.gt-sm="100%">
            <strong>Valor: </strong>R$ {{data? data.valor : 0 | number : '1.2-2'}}
        </div>
    </div>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <strong>Observação: </strong>{{getObservacao()}}
        </div>
    </div>
</div>
<br><br>
<div mat-dialog-actions model-footer>
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >   
        OK
    </button>
</div>


